var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.21 3.773h8l1 3-1.74-.87a.538.538 0 0 0-.508.02c-.486.28-1.62.85-2.752.85-1.133 0-2.266-.57-2.753-.85a.538.538 0 0 0-.507-.02l-1.74.87 1-3z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.003 8.72a5.253 5.253 0 0 1 5.207-5.947v0a5.253 5.253 0 0 1 5.207 5.948l-.679 5.088a4.569 4.569 0 0 1-4.528 3.964v0a4.569 4.569 0 0 1-4.529-3.964l-.678-5.088z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m9.21 19.773-4.682 1.171A2 2 0 0 0 3.03 22.62l-.367 2.757a3 3 0 0 0 2.974 3.396h19.146a3 3 0 0 0 2.974-3.396l-.367-2.757a2 2 0 0 0-1.498-1.676l-4.682-1.17",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.5b2e9e861cd14ba411efef960a529765.svg";
export { ForwardRef as ReactComponent };